export default "__VITE_ASSET__b0950c17__"